
import { z } from "zod";

export const EscrowStatusValues = ["CANCELLED", "DISBURSED", "DISPUTED", "FUNDED", "FUNDS_FAILED", "PARTIALLY_DISBURSED", "PARTIALLY_FUNDED", "PARTIALLY_PENDING", "PENDING", "PROBLEM", "SENT"] as const;
export const EscrowStatusSchema = /* @__PURE__ */ z.enum(EscrowStatusValues);
export const EscrowStatus: (typeof EscrowStatusSchema)["enum"] = { "CANCELLED": "CANCELLED", "DISBURSED": "DISBURSED", "DISPUTED": "DISPUTED", "FUNDED": "FUNDED", "FUNDS_FAILED": "FUNDS_FAILED", "PARTIALLY_DISBURSED": "PARTIALLY_DISBURSED", "PARTIALLY_FUNDED": "PARTIALLY_FUNDED", "PARTIALLY_PENDING": "PARTIALLY_PENDING", "PENDING": "PENDING", "PROBLEM": "PROBLEM", "SENT": "SENT" };
export type EscrowStatus = (typeof EscrowStatusValues)[number];
export const EscrowStatusDisplayNames = { "CANCELLED": "Cancelled",
"DISBURSED": "Disbursed",
"DISPUTED": "Disputed",
"FUNDED": "Funded",
"FUNDS_FAILED": "Funds failed",
"PARTIALLY_DISBURSED": "Partially disbursed",
"PARTIALLY_FUNDED": "Partially funded",
"PARTIALLY_PENDING": "Partially funded (pending)",
"PENDING": "Funded (pending)",
"PROBLEM": "Problem",
"SENT": "Sent", } satisfies Record<EscrowStatus, string>;
